import { computed } from 'vue'
import { freezeObject } from '@/global/utils/utils'
import TabActionButtons from '@/global/components/view-layouts/tabs-layout/components/TabActionButtons.vue'
import WorkOrderTaskDataInfo from '@/modules/road-maintenance-module/winter-service-v2/work-orders/overview/components/WorkOrderTaskDataInfo.vue'
import { useWorkOrderTaskFields } from '@/modules/road-maintenance-module/winter-service-v2/work-orders/overview/composables/useWorkOrderTaskFields'
import { applyTaskDataForm } from '@/modules/road-maintenance-module/winter-service-v2/work-orders/overview/composables/workOrderData'
import { WINTER_SERVICE_MODULE } from '@/modules/road-maintenance-module/winter-service-v2/common/config/constants'
import {
  WORK_ORDERS_ENDPOINT,
  WORK_ORDERS_OVERVIEW_INDEX_ROUTE,
  WORK_ORDERS_OVERVIEW_TRANSLATION_NAMESPACE as NS,
  WORK_ORDER_TASK_DATA_TAB_KEY
} from '@/modules/road-maintenance-module/winter-service-v2/work-orders/overview/config/constants'

/**
 * The "Podaci o zadatku" tab of a work order: what the plan told this order to do,
 * beside the route it was told to drive.
 *
 * Read-only screen: the backend exposes the order through `index` and `show` and
 * nothing else, so there is no `post` here and no save to reach it.
 */
export function useWorkOrderTaskData (options) {
  const { translate, workOrderId } = options || {}

  const { rows } = useWorkOrderTaskFields({ translate })

  const apiConfig = freezeObject({
    get: {
      module: WINTER_SERVICE_MODULE,
      route: `${WORK_ORDERS_ENDPOINT}/${workOrderId}`
    }
  })

  // No edit buttons - going back is the only action.
  const tabActions = computed(() => ({
    component: TabActionButtons,
    title: translate(`${NS}.work_order_details`),
    showEditButtons: false,
    showBackButton: {
      uiViewName: WORK_ORDERS_OVERVIEW_INDEX_ROUTE
    },
    visible: true
  }))

  const infoBlock = computed(() => ({
    component: WorkOrderTaskDataInfo,
    visible: true,
    rows: rows.value
  }))

  // The backend reports an order nested - the status as its own object, the whole task
  // side under `task_data` - and the fields read it flat.
  const onDataReceived = (apiData) => {
    applyTaskDataForm(apiData?.data)
  }

  return computed(() => ({
    key: WORK_ORDER_TASK_DATA_TAB_KEY,
    title: translate(`${NS}.task_information`),
    apiConfig,
    onDataReceived,
    tabContent: [
      tabActions.value,
      infoBlock.value
    ]
  }))
}
